export default "__VITE_ASSET__WHdrmagq__"